export const LAYOUTS = {
    prefs: { kind: 'flat', parentFolder: 'settings' },
    bookmarks: { kind: 'flat', parentFolder: 'settings' },
    notes: { kind: 'flat', parentFolder: 'settings' },
    prayer: { kind: 'flat', parentFolder: 'settings' },
    history: { kind: 'flat', parentFolder: 'settings' },
    memory: { kind: 'flat', parentFolder: 'settings' },
    chat: { kind: 'flat', parentFolder: 'settings' },
    'study-groups': { kind: 'flat', parentFolder: 'study-groups' },
    studies: { kind: 'nested', parentFolder: 'studies', recordFileName: 'study.json' },
    backups: { kind: 'blob', parentFolder: 'backups' },
};
/** Sanitize a string for use as a folder or filename in Drive. */
export function sanitizeFolderName(raw) {
    const trimmed = raw.trim().replace(/[\\/:*?"<>|]+/g, '-');
    const collapsed = trimmed.replace(/\s+/g, ' ');
    return collapsed.length > 0 ? collapsed.slice(0, 120) : 'untitled';
}
//# sourceMappingURL=layouts.js.map